module.exports = __webpack_public_path__ + "assets/img/b9d2-pf.svg";